const historyType = Object.freeze({
    Employment: "employment",
    Education: "education",
    SelfEmploymentTrade: "selfEmploymentTrade",
    Unemployed: "unemployed",
    Others: "others"
});

export default historyType;